import { render, staticRenderFns } from "./TripListOnly.vue?vue&type=template&id=54e07b37&scoped=true&"
import script from "./TripListOnly.vue?vue&type=script&lang=js&"
export * from "./TripListOnly.vue?vue&type=script&lang=js&"
import style0 from "./TripListOnly.vue?vue&type=style&index=0&id=54e07b37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e07b37",
  null
  
)

export default component.exports